// ** React Imports
import React, {Fragment, useEffect, useState} from 'react'

// ** Table Data & Columns
import { columns } from './data'

// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import {ChevronDown, UploadCloud} from 'react-feather'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Button, ModalHeader, ModalBody, Modal, Spinner, CardText
} from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'
import axios from "axios";
import moment from "moment";
import EditSigner from "../signers/components/edit-signer/edit-signer";
import EditUser from "./edit-user/edit-user";
import UploadTemplate from "../templates/components/upload-template/upload-template";
import DeleteUser from "../users/delete-user/delete-user";
import AreaFilter from "../area/components/filter-area/area-filter";

const UserList = () => {
    // ** States
    const [currentPage, setCurrentPage] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data)
    const [showEditUserModal, setShowEditUserModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [rowEdit, setRowEdit] = useState(null);
    const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
    const [area, setArea] = useState(null);

    useEffect(() => {
        getUsers(area);
    }, [area]);

    const toggleEditUserModal = (show, row) => {
        setRowEdit(row);
        setShowEditUserModal(show);
    }

    const toggleDeleteUserModal = (show, row) => {
        setShowDeleteUserModal(show);
        setRowEdit(row);
    }

    const toggleCreateModal = (show) => {
        setShowCreateModal(show);
    }

    const handleClose = (show, row) => {
        setShowEditUserModal(false);
        setShowCreateModal(false);
    }

    const getUsers = async (area) => {
        let str = '';
        if (area) {
            str = `?areaId=${area}`;
        }
        const response =  await axios.get(`${process.env.REACT_APP_API_URL}/users${str}`)
        const userData = response?.data?.data;
        if (userData) {
            const userList = userData.map(item => {
                return {
                    noUser: item.id,
                    userName: item.name,
                    createDate:  moment().format("DD/MM/YYYY"),
                    email: item.email,
                    isActive: item.isActive,
                    companyId: item.companyId,
                    company: item.company,
                    role: item.role,
                    areas: item.areas
                }
            })

            setData(userList);
        }
    }

    useEffect(() => {
        getUsers();
    }, []);


    // ** Function to handle filter
    const handleFilter = e => {
        const value = e.target.value
        let updatedData = []
        setSearchValue(value)

        if (value.length) {
            updatedData = data.filter(item => {

                const startsWith =
                    item.noUser.toString().toLowerCase().startsWith(value.toLowerCase()) ||
                    item.userName.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.createDate.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.email.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.role.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.areas.map(area => area.name)?.join(",")?.toLowerCase().startsWith(value.toLowerCase())

                const includes =
                    item.noUser.toString().toLowerCase().includes(value.toLowerCase()) ||
                    item.userName.toLowerCase().includes(value.toLowerCase()) ||
                    item.createDate.toLowerCase().includes(value.toLowerCase()) ||
                    item.email.toLowerCase().includes(value.toLowerCase()) ||
                    item.role.toLowerCase().includes(value.toLowerCase()) ||
                    item.areas.map(area => area.name)?.join(",")?.toLowerCase().includes(value.toLowerCase())

                if (startsWith) {
                    return startsWith
                } else if (!startsWith && includes) {
                    return includes
                } else return null
            })
            setFilteredData(updatedData)
            setSearchValue(value)
        }
    }

    // ** Function to handle Pagination
    const handlePagination = page => {
        setCurrentPage(page.selected)
    }

    // ** Pagination Previous Component
    const Previous = () => {
        return (

            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Anterior</span>
            </Fragment>
        )
    }

    // ** Pagination Next Component
    const Next = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
            </Fragment>
        )
    }

    // ** Custom Pagination
    const CustomPagination = () => (
        <ReactPaginate
            previousLabel={<Previous />}
            nextLabel={<Next />}
            forcePage={currentPage}
            onPageChange={page => handlePagination(page)}
            pageCount={searchValue.length ? Math.ceil(filteredData.length / 25) : Math.ceil(data.length / 25) || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )

    return (<Fragment>
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Usuario</CardTitle>
                </CardHeader>

                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex justify-content-end mt-1' md='6' sm='12'>
                        <Button
                            onClick={() => toggleCreateModal(true)}
                            color='primary'
                            className='btn-sm'>
                            <UploadCloud size={16} />
                            <span className={'ms-1'}>Crear Usuario</span>
                        </Button>
                    </Col>
                </Row>
                < hr/>
                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex align-items-center justify-content-end mt-1' md='3' sm='12'>
                        <Label className='me-1' for='search-input'>
                            Nombre de usuario
                        </Label>

                        <Input
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='sm'
                            id='search-input'
                            value={searchValue}
                            onChange={handleFilter}
                        />
                    </Col>

                    <Col className='d-flex align-items-center justify-content-end mt-1' md='3' sm='12'>
                        <AreaFilter isMultiSelect={false} onAreaChange={(selectedOptions) =>
                            setArea(selectedOptions.value)}/>
                    </Col>
                </Row>
                <div className='react-dataTable'>
                    <DataTable
                        noHeader
                        pagination
                        columns={columns(toggleEditUserModal, toggleDeleteUserModal)}
                        paginationPerPage={25}
                        className='react-dataTable'
                        sortIcon={<ChevronDown size={10} />}
                        paginationComponent={CustomPagination}
                        paginationDefaultPage={currentPage + 1}
                        data={searchValue.length ? filteredData : data}
                    />
                </div>
            </Card>
            <EditUser editOpts={showEditUserModal} createOpts={showCreateModal} handleClose={handleClose} item={rowEdit}/>
            <DeleteUser isOpen={showDeleteUserModal} handleClose={toggleDeleteUserModal} item={rowEdit}/>
        </Fragment>
    )
}

export default UserList
